import c0 from './bdt_destino_controller';
import c1 from './centro_setor_controller';
import c2 from './viagem_controller';
export const definitions = [
	{identifier: 'bdt-destino', controllerConstructor: c0},
	{identifier: 'centro-setor', controllerConstructor: c1},
	{identifier: 'viagem', controllerConstructor: c2},
];
